import { render, staticRenderFns } from "./ev6-swiper1.vue?vue&type=template&id=418d22ca&scoped=true&"
import script from "./ev6-swiper1.vue?vue&type=script&lang=js&"
export * from "./ev6-swiper1.vue?vue&type=script&lang=js&"
import style0 from "./ev6-swiper1.vue?vue&type=style&index=0&id=418d22ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d22ca",
  null
  
)

export default component.exports